import { Link } from "react-router-dom";
import siteicon from './img/sitelogoblack.png';
function Footer() {
    return (
        <>
          {/* <!-- Footer Start --> */}
    <div
      className="container-fluid footer mt-5 pt-5 wow fadeIn" style={{"backgroundColor":"#000"}}
      data-wow-delay="0.1s"
    >
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-4 col-md-6">
            <h4 className="text-white mb-4">
              <img
                className="img-fluid"
                src={siteicon}
                alt=""
              />
            </h4>
            <p>
            Your Trusted Partner for All Your Insurance Needs Insure Karo Secure Raho……
            </p>
            <div className="d-flex pt-2">
              <a className="btn btn-square me-1" href=""
                ><i className="fab fa-twitter"></i
              ></a>
              <a className="btn btn-square me-1" href=""
                ><i className="fab fa-facebook-f"></i
              ></a>
              <a className="btn btn-square me-1" href=""
                ><i className="fab fa-youtube"></i
              ></a>
              <a className="btn btn-square me-0" href=""
                ><i className="fab fa-linkedin-in"></i
              ></a>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <h5 className="text-light mb-4">Address</h5>
            <p>
              <i className="fa fa-map-marker-alt me-3"></i>6th Floor, Suraksha Ace, CST No. 34/3, Village Chakala, Plot No. 2-A, Andheri-Kurla Road, Andheri East, Mumbai 400059 <br/>Near Chakala Metro Station
            </p>
            <p><i className="fa fa-phone-alt me-3"></i>+918451807462</p>
            <p><i className="fa fa-envelope me-3"></i>info@ebixinsurance.com</p>
          </div>
          <div className="col-lg-4 col-md-6">
            <h5 className="text-light mb-4">Quick Links</h5>
            <Link to="/about" className="btn btn-link text-center">About Us</Link>
            <Link to="/contactus" className="btn btn-link text-center">Contact Us</Link>
            <Link to="/services" className="btn btn-link text-center">Our Services</Link>
            <a href="https://crm.bseebix.com" className="btn btn-link text-center" target="_BLANK">Become A PoSP</a>
           
          </div>
          
        </div>
      </div>
      
    </div>
    {/* <!-- Footer End --> */}
        </>
    )
}
export default Footer;